// import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, OnInit } from '@angular/core';

// @Component({
//   selector: 'app-page-progress',
//   templateUrl: './page-progress.component.html',
//   styleUrls: ['./page-progress.component.scss']
// })
// export class PageProgressComponent implements OnInit, OnChanges {
//   @Input() totalPages: number  = 3;
//   @Input() currentPage: number = 1;
//   @Output() currentPageChange = new EventEmitter<number>();
//   @Output() pageChange = new EventEmitter<number>();

//   pages: number[] = [];

//   ngOnInit(): void {
//     this.buildPages();
//   }

//   ngOnChanges(changes: SimpleChanges) {
//     // whenever inputs change, rebuild pages
//     this.buildPages();
//   }

//   private buildPages() {
//     // coerce to numbers safely (handles "5" or undefined)
//     const tp = Number(this.totalPages) || 1;
//     const cp = Number(this.currentPage) || 1;

//     this.totalPages = Math.max(1, Math.floor(tp));
//     this.currentPage = Math.max(1, Math.min(this.totalPages as number, Math.floor(cp)));

//     this.pages = Array.from({ length: this.totalPages as number }, (_, i) => i + 1);

//     // debug log so you can open console and confirm actual values
//     console.log('[PageProgress] totalPages=', this.totalPages, ' currentPage=', this.currentPage, ' pages=', this.pages);
//   }

//   isActive(page: number) { return Number(this.currentPage) === page; }
//   isCompleted(page: number) { return page < Number(this.currentPage); }

//   setPage(page: number) {
//     const clamped = Math.max(1, Math.min(Number(this.totalPages), Math.floor(page)));
//     if (clamped === Number(this.currentPage)) return;
//     this.currentPage = clamped;
//     this.emitChange();
//   }

//   next() { this.setPage(Number(this.currentPage) + 1); }
//   prev() { this.setPage(Number(this.currentPage) - 1); }

//   private emitChange() {
//     this.currentPageChange.emit(Number(this.currentPage));
//     this.pageChange.emit(Number(this.currentPage));
//   }
// }
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { gsap } from 'gsap';

@Component({
  selector: 'app-page-progress',
  templateUrl: './page-progress.component.html',
  styleUrls: ['./page-progress.component.scss'],
})
export class PageProgressComponent implements OnChanges {
  @Input() currentPage: number = 1;
  @Output() pageChange = new EventEmitter<number>();

  steps = ['Booking', 'Confirmation', 'Done'];
  @ViewChild('progressLine') progressLine!: ElementRef;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['currentPage']) {
      this.animateProgressLine();
    }
  }

  private animateProgressLine() {
    const totalSteps = this.steps.length - 1;
    const newWidth = ((this.currentPage - 1) / totalSteps) * 100;

    if(!this.progressLine?.nativeElement){
       return
    }
    gsap.to(this.progressLine.nativeElement, {
      width: `${newWidth}%`,
      duration: 0.6,
      ease: 'power2.inOut',
    });
  }

  goToStep(step: number) {
    this.pageChange.emit(step);

    // Animate circle bounce
    const circle = document.querySelectorAll('.circle')[step - 1];
    gsap.fromTo(
      circle,
      { scale: 0.8 },
      { delay: 0.7, scale: 1.5, duration: 0.3, ease: 'back.out(1.8)' }
    );
  }
}
